import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import { Skeleton } from "../ui/skeleton";
import EssentialLayout from "../menu-management/manage-essential/essential-layout";

function EssentialSkeleton() {
  return (
    <Layout2 LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}>
      <EssentialLayout>
        <div className="container flex justify-center items-center min-h-[400px]">
          <div className="p-4 space-y-6 max-w-7xl mx-auto w-full mt-5">
            {/* Header Section */}
            <div className="flex justify-between items-center">
              <Skeleton className="h-10 w-48" /> {/* Title */}
              <div className="flex gap-2">
                <Skeleton className="h-10 w-24 rounded-md" />
                <Skeleton className="h-10 w-24 rounded-md" />
              </div>
            </div>

            {/* Search & Filter */}
            <div className="flex justify-between items-center">
              <Skeleton className="h-9 w-72 rounded-md" />
              <div className="flex gap-2">
                <Skeleton className="h-9 w-24 rounded-md" />
                <Skeleton className="h-9 w-24 rounded-md" />
              </div>
            </div>

            {/* Table Header */}
            <div className="grid grid-cols-6 gap-4 px-2">
              <Skeleton className="h-6 w-full col-span-1" />
              <Skeleton className="h-6 w-full col-span-1" />
              <Skeleton className="h-6 w-full col-span-1" />
              <Skeleton className="h-6 w-full col-span-1" />
              <Skeleton className="h-6 w-full col-span-1" />
              <Skeleton className="h-6 w-full col-span-1" />
            </div>

            {/* Table Rows (5 placeholder rows) */}
            {[...Array(6)].map((_, i) => (
              <div key={i} className="grid grid-cols-6 gap-4 px-2">
                <Skeleton className="h-8 w-full col-span-1 rounded-md" />
                <Skeleton className="h-8 w-full col-span-1 rounded-md" />
                <Skeleton className="h-8 w-full col-span-1 rounded-md" />
                <Skeleton className="h-8 w-full col-span-1 rounded-md" />
                <Skeleton className="h-8 w-full col-span-1 rounded-md" />
                <Skeleton className="h-8 w-full col-span-1 rounded-md" />
              </div>
            ))}

            {/* Pagination */}
            <div className="flex justify-end gap-2">
              <Skeleton className="h-8 w-20 rounded-md" />
              <Skeleton className="h-8 w-20 rounded-md" />
            </div>
          </div>
        </div>
      </EssentialLayout>
    </Layout2>
  );
}

export default EssentialSkeleton;
